module.exports = __webpack_public_path__ + "img/fh_code_4.dca9ba8a.png";